/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';
export let placeholder:any[] = [() => {
    if (jQuery.placeholder.browser_supported()) {
        return {};
    }

    class PlaceholderDirective {
        link(scope, element) {
            element = $(element);
            var config = {
                color: '#888',
                cls: 'placeholder'
            };
            var shimCreated = false;
            if (element.is(':visible') || element.is(':animated')) {
                element._placeholder_shim(config);
                shimCreated = true;
            }

            // The following line accounts for value changes from within the code
            scope.$watch(function () {
                if (!shimCreated && element.is(':visible')) {
                    element._placeholder_shim(config);
                    shimCreated = true;
                } else if ($(element.data('placeholder')).text() != element.attr('placeholder')) {
                    $(element.data('placeholder')).text(element.attr('placeholder'));
                }

                var placeholder = element.data('placeholder');
                if (placeholder) {
                    if (element.val().length) {
                        placeholder.hide();
                    } else {
                        placeholder.show();
                    }
                }
            });
        }
    }

    return new PlaceholderDirective();
}]


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/placeholder.directive.ts